module.exports = __webpack_public_path__ + "static/media/logo-wide.53dd9897.png";